import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from '../../../core/services/v2/common.service';
import { SideBarComponentInterface } from '../dynamic-right-sidebar/sideBarComponentInterface';
import { WindowLoaderService } from '../window-loader/window-loader.service';

@Component({
  selector: 'app-SupportRequest',
  templateUrl: './SupportRequest.component.html',
  styleUrls: ['./SupportRequest.component.scss']
})
export class SupportRequestComponent implements OnInit, SideBarComponentInterface {
  @Input() opened: boolean = false;
  @Output() close = new EventEmitter();
  constructor(private commonService: CommonService, private loaderService: WindowLoaderService) { }
  setData(data: any) {
    
  }
  data: any;
  title: string = "Support Request";

  issueTypes: string[] = ["Billing", "Sales", "Technical"];

  selectedIssueType: string;
  description: string;
  files: File[] = [];

  typeRequiredAlert: boolean = false;

  ngOnInit() {
  }
  closeSidebar() {
    this.opened = false;
    this.close.emit();
  }

  attachFile(event, referral) {
    const input: HTMLInputElement = event.target;
    this.files = this.files.concat(Array.from(input.files));
  }
  removeFile(file: File) {
    const index = this.files.indexOf(file);
    if (index > -1) {
      this.files.splice(index, 1);
    }
  }

  sendSupportRequest() {
    if (!this.selectedIssueType) {
      this.typeRequiredAlert = true;
      return;
    } else {
      this.typeRequiredAlert = false;
    }

    this.loaderService.show();
    this.commonService.supportRequest(this.selectedIssueType, this.description, this.files).subscribe(
      (r) => { this.commonService.closeRightSideBar$.next(); },
      (error) => { console.error(error); },
      () => { this.loaderService.hide() }
    );
  }

  onFileDropped(droppedFiles: FileList) {
    this.files = this.files.concat(Array.from(droppedFiles));
  }

}
